<template>
    <div v-if="hasAccess && report">
        <top-nav-bar goto="/reports/list">
            <router-link :to="{ name: 'reports-edit', params: { report: $route.params.report }}" tag="button"
                         v-if="!report.completed"
                         class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase">
                <i class="fas fa-pencil mr-2"></i>
                Edit
            </router-link>
        </top-nav-bar>

        <div v-if="report" class="py-2 clearfix">
            <h3 class="text-center" v-text="report.type.name"></h3>

            <list>
                <list-item>
                    <template slot="icon">
                        <icon :icon="report.completed ? 'fas fa-check' : 'fas fa-redo-alt'"
                              :classes="(report.completed ? 'text-green' : 'text-blue') + ' w-6 h-6'"></icon>
                    </template>
                    <template slot="title">Current Status</template>
                    <template slot="sub-title">{{report.completed ? 'Completed' : 'In Progress'}}</template>
                </list-item>
            </list>
            <list>
                <list-item>
                    <template slot="icon">
                        <icon icon="far fa-clock" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Date Created</template>
                    <template slot="sub-title">{{formatDate(report.created_at)}}</template>
                </list-item>
                <list-item>
                    <template slot="icon">
                        <icon icon="fas fa-user" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Created by</template>
                    <template slot="sub-title">{{report.employee_user_name}}
                    </template>
                </list-item>
            </list>

            <list class="mb-6">
                <list-item v-for="(field, fieldIndex) in fields" :key="field.name">
                    <template slot="icon">
                        <icon :icon="field.icon" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">{{field.name}}</template>
                    <template slot="sub-title">
                        <truncate-text :text="field.value"></truncate-text>
                    </template>
                    <template v-if="field.is_file" slot="actions">
                        <a class="btn btn--colored__blue"
                           :href="documentUrl(fieldIndex)" target="_blank">
                            <i class="far fa-eye"></i>
                        </a>
                    </template>
                </list-item>
            </list>

            <div class="block md:inline-flex md:float-right px-4" v-if="!report.completed">
                <button class="btn btn--colored__red w-full" @click="deleteReport">
                    <i class="fal fa-trash"></i>
                    Delete Report
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates'
    import CanAccessView from "../mixins/CanAccessView";
    import auth from "../auth";

    export default {

        mixins: [InteractsWithDates, CanAccessView],

        data() {
            return {
                report: null,
                fields: null,
            }
        },

        mounted() {
            this.$api('hr').get(`reports/${this.$route.params.report}`)
                .then(({data}) => {
                    this.report = data.data.report;
                    this.fields = data.data.fields;
                })
        },

        methods: {
            documentUrl(type) {
                return `${process.env.VUE_APP_PORTAL}/reports/document/${this.report.id}/${type}?api_token=${auth.getToken()}&timestamp=${(new Date()).getTime()}`;
            },

            deleteReport() {
                this.$api('hr').delete(`reports/${this.$route.params.report}`)
                    .then(() => {
                        this.$router.push('/reports/list')
                        this.$noty.success('Report successfully deleted');
                    })
            }
        }
    }
</script>
